import { Button, Row, Col, Container, Modal } from "react-bootstrap";
import Select from "react-select";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { useState } from "react";
import SearchableDropdownMulti from "../../shared/SearchableDropdownMulti";
const baseURL = process.env.REACT_APP_API_JOBS;

const AddModal = ({
  showAdd,
  setShowAdd,
  increment,
  examineeStatus,
  setExamineeId,
  exam,
  activeMoamads,
  optionList,
}) => {
  const header = "שיבוץ נבחן למועד חדש";
  const [value, setValue] = useState("Select option...");
  const axiosPrivate = useAxiosPrivate("application/json");
  const [examinee1, setExaminee1] = useState({
    examinee_status: "T",
    date: new Date(),
    hakakla_lang: 0,
    hakakla_time: 0,
    notes: "",
    assessment: exam?.id,
    moamad: null,
    hrfe_examinee: null,
  });
  const [selectedOptions, setSelectedOptions] = useState();
  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value } = e.target;
    if (name === "hakala_lang" || name === "hakala_time") {
      examinee1.active = e.target.checked;
    } else
      setExaminee1((prevState) => ({
        ...prevState,
        [name]: value,
      }));
  };
  const handleChangeSDD = (id, val) => {
    setExaminee1((prevState) => ({
      ...prevState,
      moamad: id,
      //idz: val,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();

    const addData = async () => {
      try {
        const response = await axiosPrivate.post(
          baseURL + "examinee/",
          examinee1,
          {
            signal: controller.signal,
          }
        );

        isMounted && increment();
        alert("הוספת המועמד בוצעה בהצלחה");
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    addData();
    setExamineeId(null);
    setShowAdd(false);
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  function handleSelect(data) {
    setSelectedOptions(data);
    setExaminee1((prevState) => ({
      ...prevState,
      hrfe_examinee: data,
    }));
    console.log("So", selectedOptions);
  }

  return (
    <>
      <Modal
        show={showAdd}
        onHide={() => setShowAdd(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton={false}>
          <Modal.Title>
            <center>{header + " "} </center>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <Container>
              <div>
                <label>בחר מועמד:</label>
                <SearchableDropdownMulti
                  options={activeMoamads}
                  label="f_name"
                  label2="father_name"
                  label3="l_name"
                  id="id"
                  other="idz"
                  selectedVal={value}
                  handleChange={(val, id, f_name) => {
                    setValue(val);
                    //setUserEmail(email);
                    handleChangeSDD(id, val);
                  }}
                />
              </div>
              <Row>
                <Col>
                  <div className="form-group">
                    <label>מצב הנבחן:.</label>
                    <select
                      name="examinee_status"
                      onChange={handleChange}
                      value={examinee1.examinee_status}
                    >
                      <option key="0" value="" selected>
                        קבע מצב
                      </option>
                      {examineeStatus?.map((a) => (
                        <option key={a[0]} value={a[1]}>
                          {a[1]}
                        </option>
                      ))}
                    </select>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label>תאריך</label>
                    <input
                      type="date"
                      name="date"
                      className="form-control"
                      id="date"
                      value={examinee1.date}
                      onChange={handleChange}
                    />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label>מועד</label>
                    <input
                      type="time"
                      name="time"
                      className="form-control"
                      id="time"
                      value={examinee1.time}
                      onChange={handleChange}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label>הקלת שפה:.</label>
                    <input
                      type="checkbox"
                      id="hakakla_lang"
                      name="hakakla_lang"
                      defaultChecked={examinee1.hakakla_lang}
                      value={examinee1.hakakla_lang}
                      onChange={handleChange}
                    />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label>הקלת זמן:.</label>
                    <input
                      type="checkbox"
                      id="hakakla_time"
                      name="hakakla_time"
                      defaultChecked={examinee1.hakakla_time}
                      value={examinee1.hakakla_time}
                      onChange={handleChange}
                    />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <label>סיבות ההקלה</label>
                  <div className="dropdown-container">
                    <Select
                      options={optionList}
                      placeholder="בחר סיבות"
                      value={selectedOptions}
                      onChange={handleSelect}
                      isSearchable={true}
                      isMulti
                    />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <div className="form-group">
                    <label>הערות</label>
                    <textarea
                      name="notes"
                      className="form-control"
                      id="notes"
                      value={examinee1.notes}
                      onChange={handleChange}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="col-lg-6">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleSubmit}
                  >
                    שמירה
                  </button>
                </Col>
                <div className="col-lg-3"></div>
                <Col className="col-lg-3">
                  <Button
                    variant="secondary"
                    onClick={() => {
                      increment();
                      setShowAdd(false);
                      setExamineeId(null);
                    }}
                  >
                    סגירה
                  </Button>
                </Col>
              </Row>
            </Container>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddModal;
